import { useEffect, useState } from 'react';
import { useServices } from '@/app/providers';
import type { CameraRecord } from '@yawi/types';

export interface UseCamerasResult {
  cameras: CameraRecord[];
  loading: boolean;
  error: string | null;
  connectionOk: boolean | null;
  refresh: () => void;
}

export function useCameras(): UseCamerasResult {
  const { cameraRepo } = useServices();
  const [cameras, setCameras] = useState<CameraRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [connectionOk, setConnectionOk] = useState<boolean | null>(null);

  const load = async () => {
    setLoading(true);
    setError(null);

    try {
      await cameraRepo.checkConnection();
      setConnectionOk(true);
    } catch {
      setConnectionOk(false);
      setError('Sin conexión con HikCentral');
      setLoading(false);
      return;
    }

    try {
      const result = await cameraRepo.listCameras();
      setCameras(result.data);
    } catch {
      setError('Error al cargar la lista de cámaras');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return { cameras, loading, error, connectionOk, refresh: load };
}
